import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { ContractService } from '../../../service/contract/contract.service';
import { Contract } from '../../../class/contract';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.scss']
})
export class ContractComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoContract: Contract;
    public contract: Contract;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public contractService: ContractService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelContract () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/contracts/contract/contract.component.ts